import React from 'react';
import {
  PaginationWrapper,
  PaginationContainer,
  PaginationButton,
} from './styles'; // Importando os estilos
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const goToPage = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  // Funcionalidade para renderizar os botões de páginas
  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 10; // Número máximo de páginas visíveis
    const pageGroup = Math.ceil(currentPage / maxVisiblePages); // Grupo atual de páginas
    const startPage = (pageGroup - 1) * maxVisiblePages + 1;
    let endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);

    // Ajuste para ocultar as 3 primeiras páginas e mostrar as próximas 3
    let adjustedStartPage = startPage;
    let adjustedEndPage = endPage;

    if (currentPage >= startPage + maxVisiblePages - 3 && currentPage < totalPages) {
      // Se estiver próximo do final do grupo, ajusta o intervalo
      adjustedStartPage = Math.min(currentPage - (maxVisiblePages - 4), totalPages - maxVisiblePages + 1);
      adjustedEndPage = Math.min(adjustedStartPage + maxVisiblePages - 1, totalPages);
    }

    for (let i = adjustedStartPage; i <= adjustedEndPage; i++) {
      pages.push(
        <PaginationButton
          key={i}
          onClick={() => goToPage(i)}
          className={currentPage === i ? 'active' : ''}
        >
          {i}
        </PaginationButton>
      );
    }

    return pages;
  };

  return (
    <PaginationWrapper>
      <PaginationContainer>
        <PaginationButton
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
        >
          <IoIosArrowBack />
        </PaginationButton>
        {renderPageNumbers()}
        <PaginationButton
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          <IoIosArrowForward />
        </PaginationButton>
      </PaginationContainer>
    </PaginationWrapper>
  );
};

export default Pagination;